<template>
  <div>
    <v-layout row justify-center>
      <h2>{{ $t('birdcount.title') }}</h2>
    </v-layout>
    <div class="counter">
      <div data-aos-id="number" data-aos="fade-up" data-aos-duration="1000">
        <v-layout row justify-center wrap>
          <v-card class="card mt-5 "> 
            <v-card-text class="text-center number-text mt-3">
          <animated-number
            class="number"
            :value="ammountBirds"
            :round="1"
            :delay="1000"
            :complete="complete"
            :duration="3000"
            easing="easeInOutQuad"
          ></animated-number>
          <h4 v-if="complete_animation" data-aos="fade-up">{{ $t('birdcount.text_bird') }}</h4></v-card-text>
          </v-card>
          <v-card class="card mt-5">
          <v-card-text class="text-center number-text mt-3">
          <animated-number
            class="number"
            :value="ammountMammal"
            :round="1"
            :delay="1000"
            :complete="complete"
            :duration="3000"
            easing="easeInOutQuad"
          ></animated-number>
          <h4 v-if="complete_animation" data-aos="fade-up">{{ $t('birdcount.text_mammal') }}</h4></v-card-text>
          </v-card>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from "animated-number-vue";
export default {
  name: "BirdCount",
  data() {
    return {
      ammountBirds: 0,
      ammountMammal: 0,
      complete_animation: false
    };
  },
  components: {
    AnimatedNumber
  },
  computed: {
    specie() {
      var sp = this.$store.state.specie;
      var aantalBird = 0
      var aantalMammal = 0
      for(var i =0; i<sp.length;i++){
        if(sp[i]["bird"]){
          aantalBird++
        }else if(sp[i]["mammal"]){
          aantalMammal++
        }
      }
    return [aantalBird,aantalMammal]
    }
  },
  mounted() {
    this.$store.dispatch("getSpecie");
    document.addEventListener("aos:in:number", this.aosEvent);
  },
  methods: {
    aosEvent() {
      this.ammountBirds = this.specie[0];
      this.ammountMammal = this.specie[1];
      this.in_page = true;
    },
    complete() {
      this.complete_animation = true;
    }
  }
};
</script>

<style scoped>
.number {
  font-size: 150%;
}
.card-div {
  position: relative;
}
.number-text {
  font-size: 120%;
  position: relative;
  top: -10px;
}
.card {
  height: 110px;
  width: 230px;
}
.counter {
  margin-top: -30px;
}
</style>